import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[stepPreview]',
    standalone: false
})
export class StepPreviewDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
